import { FC } from 'react';
import { useAuthentication } from '@connect-x-app/hybrid-state';
import { ConnectivityStatus } from '@connect-x-app/shared-domain-models';
import { useInternetConnection } from '@connect-x-app/shared-utils';

import './statusDot.scss';

type DotSize = 'small' | 'medium' | 'large' | number;

type Props = {
  size?: DotSize;
  status?: ConnectivityStatus;
  userId?: string;
};

export const StatusDot: FC<Props> = ({ size, status, userId }) => {
  const { user } = useAuthentication();
  const { isInternetConnectionOffline } = useInternetConnection();

  const getDotSizeClassName = () => {
    if (typeof size === 'number') {
      return 'custom-size';
    }
    return size ?? 'default';
  };

  const getDotColorClassName = () => {
    if (!userId) {
      return 'default';
    }

    if (isInternetConnectionOffline) {
      return 'default';
    }

    if (userId === user?.externalId) {
      return 'success';
    }
    switch (status) {
      case ConnectivityStatus.OFFLINE:
        return 'warning';
      case ConnectivityStatus.ONLINE:
        return 'success';
      default:
        return 'default';
    }
  };

  const dotSizeClassName = getDotSizeClassName();
  const dotColorClassName = getDotColorClassName();

  const className = `status-dot ${dotSizeClassName} ${dotColorClassName}`;

  return <div className={className} />;
};
